import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PlaylistSong } from '../types.generated';

interface FavouritesState {
  data: PlaylistSong[];
}

const initialState: FavouritesState = {
  data: [],
};

const favouritesSlice = createSlice({
  name: 'favourites',
  initialState,
  reducers: {
    // Seed the list from the server on initial load
    setFavourites(state, action: PayloadAction<PlaylistSong[]>) {
      state.data = action.payload.map((item, index) => ({
        ...item,
        position: index + 1,
      }));
    },

    // Add a song optimistically to favorites
    addSongToFavouritesLocally(state, action: PayloadAction<PlaylistSong>) {
      const newSong = {
        ...action.payload,
        position: state.data.length + 1,
      };
      state.data.push(newSong);
    },

    // Remove a song locally and re-index positions
    removeSongFromFavouritesLocally(state, action: PayloadAction<number>) {
      state.data = state.data
        .filter((item) => item.song?.id !== action.payload)
        .map((item, index) => ({
          ...item,
          position: index + 1,
        }));
    },

    // Clear all favorites (if needed)
    resetFavourites(state) {
      state.data = [];
    },
  },
});

export const {
  setFavourites,
  addSongToFavouritesLocally,
  removeSongFromFavouritesLocally,
  resetFavourites,
} = favouritesSlice.actions;

export default favouritesSlice.reducer;
